// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AdminLayout_wrapper__b73dI","content":"AdminLayout_content__zVedU","formContent":"AdminLayout_formContent__dPPLd"};